/******/ (() => { // webpackBootstrap
/* eslint-disable */
class ProductSwatch extends HTMLElement {
  constructor() {
    super();

    /* ===== Bind the event handlers in order to maintain the correct context of 'this' ===== */
    this.onSwatchChangeBound = this.onSwatchChange.bind(this);
    this.onColorSwatchMouseEnterBound = this.onColorSwatchMouseEnter.bind(this);
    this.onSwatchMouseLeaveBound = this.onSwatchMouseLeave.bind(this);
  }

  connectedCallback() {
    this.colorLabel = this.querySelector('[data-color-swatch-name]');
    this.colorLabelState = this.querySelector('[data-color-swatch-state]');
    this.soldOutString = this.getAttribute('data-swatch-sold-out-string');
    this.colorSwatches = this.querySelectorAll('.swatch-element.color');
    this.sectionId = this.getAttribute('data-section-id');
    // this.setGlobalElement();
    this.setEventListeners();
    this.setColorLabelState();
    this.arabicFourSideHandle()
    // this.readMoreEventHandle();
  }
  
  setEventListeners() {
    /* ===== Attach the event listeners to the DOM elements ===== */
    this.colorSwatches.forEach(swatch => {
      swatch.addEventListener('mouseenter', this.onColorSwatchMouseEnterBound);
      swatch.addEventListener('mouseleave', this.onSwatchMouseLeaveBound);
    });

    this.addEventListener('change', this.onSwatchChangeBound);
  }

  setColorLabelState() {

    /* ===== Set the color label state based on the active swatch ===== */
    const activeSwatches = document.querySelectorAll(".swatch-element.active");
    const activeSwatch = document.querySelector('.swatch-element.active');

let option1Value = null;
let option2Value = null;
let option3Value = null;

activeSwatches.forEach(swatch => {
  const swatchValue = swatch.getAttribute("data-swatch-value");
  const optionName = swatch.closest('.swatch').getAttribute("data-option-name");

  if (optionName === 'Option1') {
    option1Value = swatchValue;
  } else if (optionName === 'Option2') {
    option2Value = swatchValue;
  }else if (optionName === 'Option3') {
    option3Value = swatchValue;
  }
});
const personalizeContainer = document.getElementById("personalize_container");
  if (!personalizeContainer || personalizeContainer.getAttribute("data-personalize") !== "true") return;
  const reverseContent = document.getElementById("ReverseOnlyContent");
  const reverseInput = reverseContent.querySelector("input");
  const frontOnly = document.getElementById("frontOnly");
  const frontInput = frontOnly.querySelector("input");
  // const customEditorForm = document.getElementById("customEditorFormFont");
  const personalizeInput = document.getElementById("personalize");
  const customEditorInput = document.getElementById("customEditor");

  // Reset values and hide all by default
  if (customEditorInput && personalizeInput && frontOnly && reverseContent && frontInput && reverseInput) {
  personalizeInput.value = "";
  customEditorInput.value = "";
  // customEditorForm.style.display = "none";
  frontOnly.style.display = "none";
  reverseContent.style.display = "none";
  frontInput.removeAttribute("required");
  reverseInput.removeAttribute("required");
  }

 setTimeout(() => {
 
      
const optionValues = [option1Value, option2Value, option3Value];
// Now loop through each selected value and show/hide sections accordingly
optionValues.forEach(data => {
  if (!data) return; // skip if value is null or undefined
console.log('data 88', data)
  const isReverse = ["reverse-only", "reverse", "reverse-side-only"].includes(data);
  const isFront = ["front-only", "front", "front-side-only"].includes(data);
  const isBoth = ["both-sides-engraving", "both-sides", "bothside"].includes(data);



  // Show reverse content if applicable
  if (isReverse) {
    reverseContent.style.display = "block";
    frontOnly.style.display = "none";
    reverseInput.setAttribute("required", "required");
  }

  // Show front content if applicable
  if (isFront) {
    frontOnly.style.display = "block";
    reverseContent.style.display = "none";
    frontInput.setAttribute("required", "required");
    
  }
    // If any of these match, show the main custom editor form
  if (isBoth) {
    reverseContent.style.display = "block";
    frontOnly.style.display = "block";
    reverseInput.setAttribute("required", "required");
    frontInput.setAttribute("required", "required");
  }
});
    

      this.readMoreEventHandle();
    }, 1000);
   
    if (!activeSwatch) return;

    const activeSwatchAvailable = activeSwatch.getAttribute('data-swatch-option-available');
    if (!this.soldOutString || !this.colorLabelState) return;

    // Set color label state (sold out or not)
    this.updateColorLabelState(activeSwatchAvailable);
    

  }

  updateColorLabelState(available) {
    
    /* ===== Set the color label state (sold out or not) ===== */
    if (this.colorLabelState) {
      this.colorLabelState.innerText = available === 'false' ? `(${this.soldOutString})` : '';
    }
  }

  onSwatchChange(event) {
    const input = event.target;
    const currentVariant = this.getVariantData(input.id);
    const productUrl = input.getAttribute('data-product-url');
    const productFetchUrl = input.getAttribute('data-product-fetch-url');
    const isCombinedListing = input.getAttribute('data-is-combined-listing') === 'true';

    this.emitVariantChangeEvent(currentVariant, productFetchUrl, productUrl, isCombinedListing);
  }

  emitVariantChangeEvent(variant, productFetchUrl, productUrl, isCombinedListing = false) {
    /* ===== Emit the variant:change event ===== */
    eventBus.emit('variant:change', {
      sectionId: this.sectionId,
      variant: variant,
      fetchURL: productFetchUrl,
      productURL: productUrl,
      isCombinedListing: isCombinedListing
    });
  }

  onColorSwatchMouseEnter(event) {
    /* ===== Update the color label on mouse enter ===== */
    this.updateColorLabel(event.currentTarget);
    
    // Add sibling hover active class
    const activeSwatch = this.querySelector('.swatch-element.active');
    if (activeSwatch && !event.currentTarget.classList.contains('active')) activeSwatch.classList.add('sibling-hover-active');
  }

  onSwatchMouseLeave() {
    /* ===== Reset the color label on mouse leave ===== */
    // Remove sibling hover active class
    const siblingHoverActiveSwatch = this.querySelector('.swatch-element.sibling-hover-active');
    if (siblingHoverActiveSwatch) siblingHoverActiveSwatch.classList.remove('sibling-hover-active');

    // Reset color label
    this.resetColorLabel();
  }

  updateColorLabel = (swatch) => {
    /* ===== Update the color label based on the swatch value ===== */
    if (!swatch) return;
    const label = swatch.getAttribute('data-value');
    const swatchAvailable = swatch.getAttribute('data-swatch-option-available');

    if (!label || !this.colorLabel) return;
    // Set color label text
    this.colorLabel.textContent = label;
    // Set color label state (sold out or not)
    this.updateColorLabelState(swatchAvailable);
  }
  setGlobalElement(data) {
  const personalizeContainer = document.getElementById("personalize_container");
  if (!personalizeContainer || personalizeContainer.getAttribute("data-personalize") !== "true") return;

  const reverseContent = document.getElementById("ReverseOnlyContent");
  const reverseInput = reverseContent.querySelector("input");
  const frontOnly = document.getElementById("frontOnly");
  const frontInput = frontOnly.querySelector("input");
  const customEditorForm = document.getElementById("customEditorFormFont");
  const personalizeInput = document.getElementById("personalize");
  const customEditorInput = document.getElementById("customEditor");
    console.log('customEditorInput', customEditorInput)
  // Reset values and hide all by default
  personalizeInput.value = "";
  customEditorInput.value = "";
  customEditorForm.style.display = "none";
  frontOnly.style.display = "none";
  reverseContent.style.display = "none";
  frontInput.removeAttribute("required");
  reverseInput.removeAttribute("required");

  // Determine action based on data
  const isReverse = ["reverse-only", "reverse", "reverse-side-only"].includes(data);
  const isFront = ["front-only", "front", "front-side-only"].includes(data);
  const isBoth = ["both-sides-engraving", "both-sides"].includes(data);

  if (isReverse || isFront || isBoth) {
    customEditorForm.style.display = "block";
  }

  if (isReverse || isBoth) {
    reverseContent.style.display = "block";
    reverseInput.setAttribute("required", "required");
  }

  if (isFront || isBoth) {
    frontOnly.style.display = "block";
    frontInput.setAttribute("required", "required");
  }
}
// 
arabicFourSideHandle(){
      // 1-side-engraving
      const engraving = document.querySelectorAll(".swatch-element.active");
        const personalizeContainer = document.getElementById("personalize_container");
  if (!personalizeContainer || personalizeContainer.getAttribute("data-personArabic") !== "true") return;

      let option1Value = null;
      let option2Value = null;
      
      engraving.forEach(swatch => {
        const swatchValue = swatch.getAttribute("data-swatch-value");
        const optionName = swatch.closest('.swatch').getAttribute("data-option-name");
      
        if (optionName === 'Option1') {
          option1Value = swatchValue;
        } else if (optionName === 'Option2') {
          option2Value = swatchValue;
        }
      });

      console.log('option1Value', option1Value, 'option2Value', option2Value)

      const optionValues = [option1Value, option2Value];
      optionValues.forEach(data => {
        if (!data) return; // skip if null/undefined
        const isSideEng = ["1-side-engraving", "one-side"].includes(data);
        const isTwoSideEng = ["2-sides-engraving","two-side", "both-sides"].includes(data);
        const isThreeSideEng = ["3-sides-engraving", "three-side"].includes(data);
        const isFourSideEng = ["4-sides-engraving", "four-side"].includes(data);
        if (isSideEng) {
          document.getElementById("oneside").style.display = "block";
          document.getElementById("fourside").style.display = "none";
          document.getElementById("twoside").style.display = "none";
          document.getElementById("threeside").style.display = "none";
        }
      
        if (isTwoSideEng) {
          document.getElementById("twoside").style.display = "block";
          document.getElementById("oneside").style.display = "none";
          document.getElementById("fourside").style.display = "none";
          document.getElementById("threeside").style.display = "none";
        }
        if (isThreeSideEng) {
          document.getElementById("threeside").style.display = "block";
          document.getElementById("oneside").style.display = "none";
          document.getElementById("twoside").style.display = "none";
          document.getElementById("fourside").style.display = "none";
        }
        if (isFourSideEng) {
          document.getElementById("fourside").style.display = "block";
          document.getElementById("oneside").style.display = "none";
          document.getElementById("twoside").style.display = "none";
          document.getElementById("threeside").style.display = "none";
        }
      });
    }


  resetColorLabel = () => {
    /* ===== Reset the color label to the active swatch value ===== */
    const activeSwatch = this.querySelector('.swatch-element.color.active');
    if (!activeSwatch || !this.colorLabel) return;

    const activeSwatchValue = activeSwatch.getAttribute('data-value');
    const swatchAvailable = activeSwatch.getAttribute('data-swatch-option-available');
    if (!activeSwatchValue) return;

    // Reset color label text
    this.colorLabel.textContent = activeSwatchValue;
    // Reset color label state (sold out or not)
    this.updateColorLabelState(swatchAvailable);
  }	
  readMoreEventHandle = () => {
    const descriptionEl = document.getElementById("product-description-read");
  const toggleBtn = document.getElementById("toggle-description");

  if (!descriptionEl || !toggleBtn) return;

  const fullText = descriptionEl.innerHTML;
  const words = fullText.split(" ");
  const wordLimit = 40;

  if (words.length <= wordLimit) {
    toggleBtn.style.display = "block";
    
    return;
  }

  const truncatedText = words.slice(0, wordLimit).join(" ") + "...";

  let isExpanded = false;
  descriptionEl.innerHTML = truncatedText;

  toggleBtn.addEventListener("click", function (e) {
    e.preventDefault();
    if (isExpanded) {
      descriptionEl.innerHTML = truncatedText;
      toggleBtn.textContent = "Read More";
      descriptionEl.classList.remove('open')
    } else {
      descriptionEl.innerHTML = fullText;
      toggleBtn.textContent = "Read Less";
      descriptionEl.classList.add('open')
    }
    isExpanded = !isExpanded;
  });
  }
  removeEventListeners() {
    /* ===== Remove the event listeners from the DOM elements ===== */
    this.colorSwatches.forEach(swatch => {
      swatch.removeEventListener('mouseenter', this.onColorSwatchMouseEnterBound);
      swatch.removeEventListener('mouseleave', this.onSwatchMouseLeaveBound);
    });

    this.removeEventListener('change', this.onSwatchChangeBound);
  }

  getVariantData(inputId) {
    return JSON.parse(this.getVariantDataElement(inputId).textContent);
  }

  getVariantDataElement(inputId) {
    return this.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
  }

  disconnectedCallback() {
    /* ===== Remove the event listeners when the element is removed from the DOM ===== */
    this.removeEventListeners();
  }
}

if (!window.customElements.get('product-swatch')) {
  window.customElements.define('product-swatch', ProductSwatch);
}

/******/ })();